import { useUserStore } from '@lib/store';
import { LocalStorageUtils } from './localStorageUtils';
import { type ConfirmLoginResponse, type User } from '@shared/api';

export class AuthUtils {
  private static tempToken = '';
  private static registerTempToken = '';
  private static verifyTempToken = '';
  private static recoveryTempToken = '';

  static getTempToken = () => this.tempToken;
  static setTempToken = (tempToken: string) => (this.tempToken = tempToken);
  static removeTempToken = () => (this.tempToken = '');
  static getRegisterTempToken = () => this.registerTempToken;
  static setRegisterTempToken = (registerTempToken: string) => (this.registerTempToken = registerTempToken);
  static removeRegisterTempToken = () => (this.registerTempToken = '');
  static getVerifyTempToken = () => this.verifyTempToken;
  static setVerifyTempToken = (verifyTempToken: string) => (this.verifyTempToken = verifyTempToken);
  static removeVerifyTempToken = () => (this.registerTempToken = '');
  static getRecoveryTempToken = () => this.recoveryTempToken;
  static setRecoveryTempToken = (recoveryTempToken: string) => (this.recoveryTempToken = recoveryTempToken);
  static removeRecoveryTempToken = () => (this.recoveryTempToken = '');

  static getUser = () => useUserStore.getState().data;
  static setUser = (data: ConfirmLoginResponse): User => {
    const user: User = {
      auth: true,
      authenticationType: 'Password',
      isAuthenticated: true,
      lastLogin: data.lastLoginDate,
      name: data.loggedInUser,
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
      mustUpdatePassword: data.mustUpdatePassword || false,
      version: data.version,
    };
    useUserStore.getState().setUser(user);
    LocalStorageUtils.setUser(user);

    return user;
  };
  static clearUser = () => {
    useUserStore.getState().clear();
    LocalStorageUtils.removeUser();
  };

  static login = (data: ConfirmLoginResponse) => {
    this.removeTempToken();
    const user = this.setUser(data);
    if (!user.mustUpdatePassword) window.location.replace('/');
    else window.location.replace('/profile/password');
  };

  static logout = () => {
    useUserStore.getState().setUser(null);
    LocalStorageUtils.removeUser();
    location.href = '/';
  };
}
